/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accessMgmt.vue?vue&type=template&id=dd23b958"
import script from "./accessMgmt.vue?vue&type=script&lang=js"
export * from "./accessMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports